import { HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SUPPRESS_ERROR_MESSAGE } from 'src/app/interception/error-handler.interceptor';
import { criarQueryParams, Filtro } from 'src/app/model/filtro';
import { ChronosHttp } from 'src/app/seguranca/chronos-http';
import { environment } from 'src/environments/environment';
import {
  FaturaUso,
  Pagamamento,
  PagamamentoRequest,
} from '../models/pagamento';

@Injectable({
  providedIn: 'root',
})
export class PagamentoService {
  private http = inject(ChronosHttp);

  url: string;
  urlFatura: string;

  constructor() {
    this.url = `${environment.apiUrl}/financeiro/pagamento/fornecedores`;
    this.urlFatura = `${environment.apiUrl}/financeiro/pagamento/uso-erp/empresas`;
  }

  buscar(filtro: Filtro) {
    const params = criarQueryParams(filtro, false, false);

    return this.http.get<Pagamamento[]>(`${this.url}`, {
      params: params,
    });
  }

  pagar(pagamento: PagamamentoRequest) {
    return this.http.post<PagamamentoRequest[]>(`${this.url}`, pagamento);
  }

  buscarFaturarUso(idempresa: number) {
    return this.http.get<FaturaUso>(`${this.urlFatura}/${idempresa}/fatura`, {
      context: new HttpContext().set(SUPPRESS_ERROR_MESSAGE, true),
    });
  }
}
